import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography'
import Box from "@mui/material/Box";
import Copyright from '../shared/copyright';
export default function Footer() {
  return (
      <AppBar position="fixed" color="primary" sx={{ top: 'auto', bottom: 0 ,height:40,zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Copyright  sx={{ mt:1}}/>
      </AppBar>
  );
}